module.exports = __webpack_public_path__ + "static/media/underground.32c752e6.mp3";